import { h } from '@stencil/core';
import { MAX_LINE_LIMIT, MAX_IMG_LIMIT } from '@pes-ui/utils';
import cn from 'classnames';
import { isMobile } from '../../../globals/utils';
export class ProductDescription {
  resizeWindowHandler() {
    this.isMobile = isMobile();
  }
  constructor() {
    this.title = undefined;
    this.description = undefined;
    this.readMoreLabel = undefined;
    this.readLessLabel = undefined;
    this.descriptionImages = undefined;
    this.isMobile = isMobile();
    this.el.dir = document.documentElement.dir || 'auto';
  }
  renderContent() {
    return (h("pes-description", { class: "description", text: this.description, expandLabel: this.readMoreLabel, collapseLabel: this.readLessLabel, numLinesToShow: {
        desktop: MAX_LINE_LIMIT === null || MAX_LINE_LIMIT === void 0 ? void 0 : MAX_LINE_LIMIT.desktop,
        mobile: MAX_LINE_LIMIT === null || MAX_LINE_LIMIT === void 0 ? void 0 : MAX_LINE_LIMIT.mobile,
      }, isPdp: true }));
  }
  renderImageSection() {
    var _a;
    return (h("se-carousel", { pagination: this.isMobile, "arrows-overlay": true }, (_a = this.descriptionImages) === null || _a === void 0 ? void 0 : _a.map((item) => {
      var _a, _b;
      const { url, title } = item;
      if (!title || !url)
        return null;
      return (h("se-carousel-item", { class: cn({
          'product-description-img-with-carousal': ((_a = this.descriptionImages) === null || _a === void 0 ? void 0 : _a.length) > MAX_IMG_LIMIT,
        }, { 'product-description-img': ((_b = this.descriptionImages) === null || _b === void 0 ? void 0 : _b.length) <= MAX_IMG_LIMIT }) }, h("se-block", { margin: "medium" }, h("pes-lazy-img", { src: url, alt: title }))));
    })));
  }
  renderMobileView() {
    return (h("pes-collapsible-container", null, h("pes-section-header", { slot: "header", class: "description__heading" }, this.title), this.renderContent(), this.renderImageSection()));
  }
  renderDesktopView() {
    return (h("pes-section-with-header", { headingLabel: this.title, withColumns: true }, this.renderContent(), this.renderImageSection()));
  }
  render() {
    if (!this.description)
      return null;
    return this.isMobile ? this.renderMobileView() : this.renderDesktopView();
  }
  static get is() { return "pes-product-description"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["product-description.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["product-description.css"]
    };
  }
  static get properties() {
    return {
      "title": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "title",
        "reflect": false
      },
      "description": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "description",
        "reflect": false
      },
      "readMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "read-more-label",
        "reflect": false
      },
      "readLessLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "read-less-label",
        "reflect": false
      },
      "descriptionImages": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Array<TDescriptionImageObj>",
          "resolved": "TDescriptionImageObj[]",
          "references": {
            "Array": {
              "location": "global"
            },
            "TDescriptionImageObj": {
              "location": "import",
              "path": "../specifications/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get states() {
    return {
      "isMobile": {}
    };
  }
  static get elementRef() { return "el"; }
  static get listeners() {
    return [{
        "name": "resize",
        "method": "resizeWindowHandler",
        "target": "window",
        "capture": false,
        "passive": true
      }];
  }
}
